import styled from '@emotion/styled'
import React, { useState } from 'react'
import { Popover, ArrowContainer } from 'react-tiny-popover'

export type HelpButtonProps = {
  content: JSX.Element
  style?: React.CSSProperties
}

export const HelpButton = ({ content, style }: HelpButtonProps) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false)

  return (
    <Popover
      isOpen={isPopoverOpen}
      padding={10}
      content={({ position, childRect, popoverRect }) => (
        <ArrowContainer
          position={position}
          childRect={childRect}
          popoverRect={popoverRect}
          arrowSize={10}
          arrowColor='#f2f2f2'
        >
          <HelpButtonContent>{content}</HelpButtonContent>
        </ArrowContainer>
      )}
      onClickOutside={() => setIsPopoverOpen(false)}
      positions={['right', 'top', 'left', 'bottom']}
    >
      <Container style={style} onClick={() => setIsPopoverOpen(!isPopoverOpen)}>
        ?
      </Container>
    </Popover>
  )
}

const Container = styled.span`
  margin-left: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #009adc;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
  flex-shrink: 0;
`

const HelpButtonContent = styled.div`
  padding: 5px;
  background-color: #f2f2f2;
  border-radius: 4px;
  max-width: 320px;
`
